export default "__VITE_ASSET__DvC8v00v__"